import React from 'react';
import { useTranslation } from 'react-i18next';
import { Page, PageHeader } from '@tanium/react-page';
import { WelcomeBanner } from '@tanium/react-welcome-banner';
import { ManageAccountSection } from './ManageAccount/ManageAccountSection';
import { IdpConfigsProvider } from '../hooks/useIdentityProviderConfigs';
import { useTenant } from '../hooks/useTenant';
import { DocLinks } from '../utilities/constants';

export const OverviewPage: React.VFC = () => {
  const { t } = useTranslation();
  const { tenant } = useTenant();

  return (
    <Page header={<PageHeader heading={''} />}>
      {!tenant?.isMsp && (
        <WelcomeBanner
          productName={t('Tanium Account')}
          header={t('Welcome to your Tanium Account')}
          summary={t('To learn more about how to use your Tanium Account, see the Tanium Account User Guide.')}
          userGuideLinkUrl={DocLinks.DOCS_HOME}
          releaseNotesLinkUrl={false}
          dataSheetLinkUrl={false}
          resourceCenterLinkUrl={false}
        />
      )}
      <IdpConfigsProvider>
        <ManageAccountSection />
      </IdpConfigsProvider>
    </Page>
  );
};
